import React from "react";

import { SelectList } from "@common/selectList";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function AddMember({ resources, addResources, removeResources }: Props) {
  return (
    <SelectList listClassName={styles.list} multiple>
      {() => ({
        input: <AddAllocationIcon className={styles.icon} />,
        list: (
          <ResourceAllocationMenu
            allocatedResources={resources}
            select={addResources}
            unSelect={removeResources}
            openedViews={["resources"]}
          />
        ),
      })}
    </SelectList>
  );
}

export { AddMember };
